'use client';

import 'cherry-markdown/dist/cherry-markdown.css';
import './index.css';
import { useEffect, useRef, useState } from 'react';
import { create } from 'zustand';
import { RightDocumentMenu } from '../menu';
import { Loading } from 'tdesign-react';

interface IToolDocumentProps {
  text: string;
  autoCalcMenuHeight?: boolean;
}

export interface IHeader {
  level: number;
  id: string;
  text: string;
}

const getHeaderList = (htmlValue: string) => {
  const headerList: any = [];
  const headerRegex = /<h([1-2]).*?id="([^"]+?)".*?>(.+?)<\/h[0-2]>/g;
  htmlValue.replace(
    headerRegex,
    (match: string, level: number, id: string, text: string) => {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = text.replace(/<[^>]*>/g, '');
      const v = textarea.value;
      headerList.push({ level: +level, id, text: v.trim() });
      return match;
    }
  );
  return headerList;
};

export const useToolDocument = create<{
  headers: Array<IHeader>;
}>(() => ({
  headers: [],
}));

export const ToolDocument: React.FC<IToolDocumentProps> = ({
  text,
  autoCalcMenuHeight = true,
}) => {
  const [htmlValue, setHtmlValue] = useState('');
  const [loading, setLoading] = useState(true);
  const cherryInstanceRef = useRef<any>(null);

  useEffect(() => {
    const CherryEngine =
      require('cherry-markdown/dist/cherry-markdown.engine.core').default;
    if (!cherryInstanceRef.current) {
      cherryInstanceRef.current = new CherryEngine({});
    }

    if (cherryInstanceRef.current) {
      setLoading(true);
      console.time('makeHtml');

      const value = cherryInstanceRef.current.makeHtml(text);
      if (autoCalcMenuHeight) {
        const headerList = getHeaderList(value);
        useToolDocument.setState({ headers: headerList });
      }
      setHtmlValue(value);
      console.timeEnd('makeHtml');
      setLoading(false);
    }
  }, [text, autoCalcMenuHeight]);
  const cls = autoCalcMenuHeight
    ? '[&_h1]:scroll-mt-[118px] [&_h2]:scroll-mt-[118px] [&_h3]:scroll-mt-[118px]'
    : '';
  return loading ? (
    <div className="w-full flex justify-center">
      <Loading className="w-10 mobile:w-5" />
    </div>
  ) : (
    <div
      className={`cherry-markdown text-primary ${cls}`}
      dangerouslySetInnerHTML={{ __html: htmlValue }}
    />
  );
};
